import React from 'react';
import GenericPullAndPushToolView from '../GenericPullAndPushToolView';
import SpectralConfigListing from './SpectralConfigListing';
import SpectralCredentialsForm from './SpectralCredentialsForm';

const SpectralPullAndPushView = (props) => (
    <GenericPullAndPushToolView 
        {...props}
        PullCredentialForm={SpectralCredentialsForm}
        PullConfigListingView={SpectralConfigListing}
     />
);

export default SpectralPullAndPushView;
